import {
  MobileResourceEventGroupViewModel,
  MobileResourceEventViewModel,
  MobileResourceTypeViewModel,
  MobileResourceViewModel,
} from '../viewModels/mobileData.resources.viewModel';

export class ResourcesConstants {
  public static readonly ObjectTypeName_MtResourceEvent: string = 'MtResourceEvent';
  public static readonly PersistenceCategory_ResourceEvent: string = 'ResourceEvent';
  public static readonly TimespanOffFormatString: string = '#########0.00 h';
  public static readonly ResultValueFormatString: string = '#########0.00';
  public static readonly SimpleDateFormatOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };
}

export class ResourcesDataContext {
  private _dsResources: MobileResourceViewModel[];
  private _dsResourceEvents: MobileResourceEventViewModel[];
  private _workId: string | undefined;

  public dsResourceTypes: MobileResourceTypeViewModel[];
  public navigationContext: ResourcesNavigationContext;

  public set workId(value: string | undefined) {
    this._workId = value;
    this.dsResourceTypes.forEach((resType) => {
      resType.resourceEventTypeGroups.forEach((resEvtTypeGroup) => (resEvtTypeGroup.workId = this._workId));
    });
  }

  public get isInWorkMode(): boolean {
    return this._workId ? true : false;
  }

  public get dsResources(): MobileResourceViewModel[] {
    if (!this._dsResources) {
      this._dsResources = this.dsResourceTypes.reduce((pn, u) => [...pn, ...u.resources], []);
    }
    return this._dsResources;
  }

  public get dsResourceEvents(): MobileResourceEventViewModel[] {
    if (!this._dsResourceEvents) {
      this._dsResourceEvents = this.dsResourceTypes
        .reduce((pn, u) => [...pn, ...u.resources], [])
        .reduce((pn, u) => [...pn, ...u.resourceEvents], []);
    }
    return this._dsResourceEvents;
  }

  constructor() {}
}

export class ResourcesNavigationContext {
  public resourcesDataContext: ResourcesDataContext;
  public resourceEventGroup: MobileResourceEventGroupViewModel;
  public resourceEventIndexInGroup?: number;
  public discardResourceEventWhenNavigateBack: boolean;
  public isDirectSingleNavigation: boolean;

  public get resourceEvent(): MobileResourceEventViewModel {
    let resEvt: MobileResourceEventViewModel = null;
    if (this.resourceEventIndexInGroup || this.resourceEventIndexInGroup === 0) {
      resEvt = this.resourceEventGroup.resourceEvents[this.resourceEventIndexInGroup];
    }
    return resEvt;
  }
}

export class ResourceTypeViewPackage {
  allResourceTypes: MobileResourceTypeViewModel[];
}

export enum ResourceTypeKind {
  Vehicle = '1',
  DeviceOrMachine = '2',
  Personnel = '3',
  Material = '4',
}

export enum ResourceEventTypeKindDeviceOrMachine {
  OperatingHours = '1',
}

export enum ResourceEventTypeKindVehicle {
  Mileage = '1',
  OperatingHours = '2',
  Downtime = '3',
  WaterFilling = '4',
}

export enum ResourceEventTypeKindMaterial {
  MaterialExpense = '1',
}

export enum ResourceEventTypeKindPersonnel {
  WorkingTimes = '1',
}

export enum DetailPageWorkMode {
  Standard = 1,
  New,
  Edit,
  DirectSingleNavigation,
}
